import { range } from 'lodash';
import * as React from 'react';
import { IBookingReceipt } from '../../../data/entities/event/booking';
import { Table, Tbody, Td, Th, Thead, Tr } from '../table';
import { DeletableRow } from './DeletableRow';
import { IPendingBookingReceipt } from './helpers';

export interface IReceiptTableProps {
	receipts: IPendingBookingReceipt[];
	metadata?: Record<string, string | string[]>;
	extraColumns?: string[];
	extraCells?: (receipt: IPendingBookingReceipt) => React.ReactNode[];
	copyReceipt: (receipt: IBookingReceipt) => any;
	deleteReceipt: (receipt: IBookingReceipt, del: boolean) => any;
}

export const ReceiptTable: React.FC<IReceiptTableProps> = (props) => {
	const extraColumnCount = props.extraColumns ? props.extraColumns.length : 0;

	return <Table className="booking-payment-internal">
		<Thead>
			<Tr>
				<Th>Date</Th>
				<Th>Amount</Th>
				{
					props.extraColumns && props.extraColumns.map((column) => <Th key={column}>{column}</Th>)
				}
				<Th>Comments</Th>
				<Th>Method</Th>
				<Th></Th>
			</Tr>
		</Thead>
		<Tbody>
			{
				props.receipts.sort((a, b) => Number(a.date) - Number(b.date)).map((receipt: IPendingBookingReceipt, i: any) => {
					return <DeletableRow
						key={i}
						receipt={receipt}
						copyReceipt={props.copyReceipt}
						deleteReceipt={props.deleteReceipt}
					>
						{props.extraCells && props.extraCells(receipt).map((r, j) => <Td key={j} className="booking-payment__cell">{r}</Td>)}
					</DeletableRow>;
				})
			}

			{
				props.metadata && Object.keys(props.metadata).length > 0 &&
				<Tr>
					{
						range(5 + extraColumnCount).map((i) => <Th key={i} />)
					}
				</Tr>
			}

			{
				props.metadata && Object.entries(props.metadata).map(([key, value]) => {
					const cellArray = Array.isArray(value) ? value : [value];

					return <Tr key={key}>
						<Td><span className="booking-payment-internal__text-highlight">{key}</span></Td>
						{
							cellArray.map((v, i) => <Td key={i}>{v}</Td>)
						}
						{
							range(4 + extraColumnCount - cellArray.length)
								.map((i) => <Td key={i} />)
						}
					</Tr>;
				})
			}
		</Tbody>
	</Table>;
};
